export default __webpack_public_path__ + "images/c6c71535ef238c47af70a1314e5e16fc-level1.png";